export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user', 'group', 'buddies'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'BGG Owners',
        category: 'Game',
        description: 'Number of BGG users that own this game.',
        summarise: {
            prefix: 'Owned by',
            postfix: 'BGG users'
        },
        unit: 'owner'
    },
    rules: {
        linked: [],
        legacy: ['bgg.owners']
    }
}
